import React, { useEffect, useState } from "react";
import WishesItem from "./WishesItem";
import { db } from "../firebase";
import { onValue, ref } from "firebase/database";

export default function WishesSection() {
  const [wishes, setWishes] = useState([]);

  useEffect(() => {
    onValue(ref(db), (snapshot) => {
      setWishes([]);
      const data = snapshot.val();
      if (data !== null) {
        Object.values(data).map((item) => {
          setWishes((oldArray) => [item, ...oldArray]);
        });
      }
    });
  }, []);

  if (wishes.length < 1) return <></>;
  return (
    <div className="wishes-item-container">
      {wishes.map((item, i) => (
        <WishesItem id={i} nama={item.nama} ucapan={item.ucapan} />
      ))}
    </div>
  );
}
